export function calculations(
  hrsSpentOnLowComplexityPerDay: number,
  numOfHrEmployees: number,
  ticketsPerDay: number,
  improveNumberOfTickets: number,
  improveProductivity: number,
  jsondata: any,
) {
  // Calculations regarding Savings  by self-serviced queries (year)
  const { numOfWorkingDays } = jsondata;
  const hrsSpentOnLowComplexityPerYear =
    numOfWorkingDays * 8 * hrsSpentOnLowComplexityPerDay;
  const watsonBenchmarksTimeOnLowComplexityPerYear = 3300;
  const watsonBenchmarksValueOnLowComplexityPerYear = 100000 * 1.2685;
  const oneHourValueOnLowComplexityTask =
    watsonBenchmarksValueOnLowComplexityPerYear /
    watsonBenchmarksTimeOnLowComplexityPerYear;
  const minSavingsBySelfServicedQueriesPerYear = Math.round(
    hrsSpentOnLowComplexityPerYear * oneHourValueOnLowComplexityTask,
  );

  // Calculations regarding Reduce the tickets raised ad-hoc
  const reductionInTicketsRaseMin = 0.64;
  const reductionInTicketsRaseMax = 0.64;

  const totalHrCostPerDayMin =
    jsondata.eployeeTotalCostYear.min / numOfWorkingDays;
  const totalHrCostPerDayMax =
    jsondata.eployeeTotalCostYear.max / numOfWorkingDays;

  const totalCostOfTicketsAfterWatsonMin =
    reductionInTicketsRaseMin *
    jsondata.hrAvarageCicleTime.min *
    totalHrCostPerDayMin *
    260;

  const totalCostOfTicketsAfterWatsonMax =
    reductionInTicketsRaseMax *
    jsondata.hrAvarageCicleTime.max *
    totalHrCostPerDayMax *
    260;

  const reduceTheTicketsRaisedMin = Math.round(
    numOfHrEmployees *
      ticketsPerDay *
      totalCostOfTicketsAfterWatsonMin *
      improveNumberOfTickets *
      jsondata.employeeRelationsheapManagers.min,
  );

  const reduceTheTicketsRaisedMax = Math.round(
    numOfHrEmployees *
      ticketsPerDay *
      totalCostOfTicketsAfterWatsonMax *
      improveNumberOfTickets *
      jsondata.employeeRelationsheapManagers.max,
  );

  // Calculations regarding Improve productivity
  const savingsInHoursPerYearMin = 12000 * 4;
  const savingsInHoursPerYearMax = 50000;

  const totalHrCostPerHrMin = totalHrCostPerDayMin / 8;
  const totalHrCostPerHrMax = totalHrCostPerDayMax / 8;

  const costOfHoursSavedMin = savingsInHoursPerYearMin * totalHrCostPerHrMin;
  const costOfHoursSavedMax = savingsInHoursPerYearMax * totalHrCostPerHrMax;

  const improveProductivityMin = Math.round(
    numOfHrEmployees *
      jsondata.employeeRelationsheapManagers.min *
      costOfHoursSavedMin *
      improveProductivity,
  );

  const improveProductivityMax = Math.round(
    numOfHrEmployees *
      jsondata.employeeRelationsheapManagers.max *
      costOfHoursSavedMax *
      improveProductivity,
  );

  const hrTotalSavingsMin =
    minSavingsBySelfServicedQueriesPerYear +
    reduceTheTicketsRaisedMin +
    improveProductivityMin;

  const hrTotalSavingsMax =
    minSavingsBySelfServicedQueriesPerYear +
    reduceTheTicketsRaisedMax +
    improveProductivityMax;
  return {
    minSavingsBySelfServicedQueriesPerYear,
    maxSavingsBySelfServicedQueriesPerYear:
      minSavingsBySelfServicedQueriesPerYear,
    reduceTheTicketsRaisedMin,
    reduceTheTicketsRaisedMax,
    improveProductivityMin,
    improveProductivityMax,
    hrTotalSavingsMin,
    hrTotalSavingsMax,
  };
}
